











































































































import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ShippingCompany from '@/api/shipping/index'
import VipTag from '@/api/vip/vipTag/index'
import { FormItem } from '../../../types/iview/form'
@Component({
  components: {},
})
export default class EditTag extends AbpBase {
  form = {
    name: null,
    starttotalTransaction: null,
    endtotalTransaction: null,
    starttotalAmount: null,
    endtotalAmount: null,
    isAutoTag: 0, // 0 自动 1 手动
    // 0 系统标签 1 导购标签
    tagType: 0,
    isActive: false,
    isAutoTagItem: null, // 10 累计交易笔数 11 累计交易金额
    isAutoTagItemTranMoths: null,
    isAutoTagItemAmountMoths: null,
    customTime1: [],
    customTime2: [],
  }

  validateValue(rule, value, callback) {
    if (this.form.isAutoTag != 0) {
      callback()
    } else if (!value && this.form.isAutoTagItem != 10) {
      callback(new Error('请输入累计购买金额'))
    } else {
      callback()
    }
  }
  validateNum(rule, value, callback) {
    let vm = this
    if (this.form.isAutoTag != 0) {
      callback()
    } else if (!value && this.form.isAutoTagItem == 10 && this.form.starttotalTransaction == null) {
      callback(new Error('请输入累计成功交易笔数'))
    } else if (!value && this.form.isAutoTagItem == 11 && this.form.starttotalAmount == null) {
      callback(new Error('请输入累计成功交易金额'))
    } else if (!value && this.form.isAutoTagItem == null) {
      callback(new Error('请选择自动打标签的条件'))
    } else {
      callback()
    }
  }
  validateNumber(rule, value, callback) {
    let vm = this
    console.log(value)
    if (this.form.isAutoTag != 0) {
      callback()
    } else if (this.form.isAutoTagItem == 10 && this.form.starttotalTransaction == null) {
      callback(new Error('请输入累计成功开始笔数'))
    } else if (this.form.endtotalTransaction == null && this.form.isAutoTagItem == 10) {
      callback(new Error('请输入累计成功截至笔数'))
    } else if (
      this.form.isAutoTagItem == 10 &&
      (this.form.isAutoTagItemTranMoths == null || this.form.customTime1[0] == '')
    ) {
      console.log(this.form.customTime1);
      callback(new Error('请选择最近月份'))
    } else {
      callback()
    }
  }
  validatePrice(rule, value, callback) {
    let vm = this
    if (this.form.isAutoTag != 0) {
      callback()
    } else if (this.form.isAutoTagItem == 11 && this.form.starttotalAmount == null) {
      callback(new Error('请输入累计成功开始金额'))
    } else if (this.form.isAutoTagItem == 11 && this.form.endtotalAmount == null) {
      callback(new Error('请输入累计成功截至金额'))
    } else if (
      this.form.isAutoTagItem == 11 &&
      (this.form.isAutoTagItemAmountMoths == null || this.form.customTime2[0] == '')
    ) {
      callback(new Error('请选择最近月份'))
    } else {
      callback()
    }
  }
  isAutoLabel(rule, value, callback) {
    let vm = this
    if (this.form.isAutoTag != 0) {
      callback()
    } else if (this.form.isAutoTag == 0 && this.form.isAutoTagItem == null) {
      callback(new Error('请选择自动打标签的条件'))
    } else {
      callback()
    }
  }

  ruleForm = {
    name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
    totalTransaction: [{ validator: this.validateNum, trigger: 'blur' }],
    totalAmount: [{ validator: this.validateValue, trigger: 'blur' }],
    validateNumber: [{ validator: this.validateNumber, trigger: 'blur' }],
    validatePrice: [{ validator: this.validatePrice, trigger: 'blur' }],
  }

  created() {
    this.getVipTagDetail()
  }

  /**
   * 获取标签详情
   */
  getVipTagDetail() {
    let id = this.$route.query['id']
    if (id) {
      VipTag.getVipTagDetail(id.toString()).then((res) => {
        console.log(res.data)
        res.data.isAutoTag = res.data.isAutoTag ? 0 : 1
        this.form = res.data
        if (res.data.autoTagCondition) {
          const autoTagCondition = JSON.parse(res.data.autoTagCondition)
          this.form.isAutoTagItem = autoTagCondition.AutoTagType == 0 ? 10 : 11
          if (JSON.parse(res.data.autoTagCondition).AutoTagType == 0) {
            this.form.starttotalTransaction = autoTagCondition.MinDealValue
            this.form.endtotalTransaction = autoTagCondition.MaxDealValue
            if (autoTagCondition.ScaleType == 3) {
              this.form.customTime1 = autoTagCondition.customTime.split(',')
              this.form.isAutoTagItemTranMoths = 99
              this.form.customTime2 = []
            } else {
              this.form.isAutoTagItemTranMoths =
                autoTagCondition.ScaleType == 0 ? 3 : autoTagCondition.ScaleType == 1 ? 6 : 12
            }

            this.form.starttotalAmount = null
            this.form.endtotalAmount = null
          } else {
            this.form.starttotalAmount = autoTagCondition.MinDealValue
            this.form.endtotalAmount = autoTagCondition.MaxDealValue
            if (autoTagCondition.ScaleType == 3) {
              this.form.customTime2 = autoTagCondition.customTime.split(',')
              this.form.isAutoTagItemAmountMoths = 99
              this.form.customTime1 = []
            } else {
              this.form.isAutoTagItemAmountMoths =
                autoTagCondition.ScaleType == 0 ? 3 : autoTagCondition.ScaleType == 1 ? 6 : 12
            }

            this.form.starttotalTransaction = null
            this.form.endtotalTransaction = null
          }
        } else {
          this.form.starttotalTransaction = null
          this.form.endtotalTransaction = null
          this.form.starttotalAmount = null
          this.form.endtotalAmount = null
        }
      })
    }
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    console.log(this.form)
    console.log(this.form.isAutoTag, this.form.isAutoTagItem)
    if (this.form.isAutoTag == 0 && (this.form.isAutoTagItem == null || this.form.isAutoTagItem == 0)) {
      this.$Notice.warning({
        desc: '请选择自动打标签的条件',
      })
      return
    }
    if (this.form.isAutoTag == 1) {
      this.form.isAutoTagItem = null
    }
    form.validate((valid) => {
      if (valid) {
        let obj: any = JSON.parse(JSON.stringify(this.form))
        const isAutoTag = this.form.isAutoTag == 0 ? true : false
        const isAutoTagItem = this.form.isAutoTagItem == 10 ? true : false
        console.log(isAutoTag, isAutoTagItem)
        if (!isAutoTag) {
          obj.starttotalTransaction = null
          obj.endtotalTransaction = null
          obj.starttotalAmount = null
          obj.endtotalAmount = null
          obj.isAutoTagItemTranMoths = null
          obj.isAutoTagItemAmountMoths = null
        } else {
          if (!isAutoTagItem) {
            obj.starttotalTransaction = null
            obj.endtotalTransaction = null
            obj.isAutoTagItemTranMoths = null
            if (this.form.isAutoTagItemAmountMoths == 99) {
              obj.autoTagCondition = {
                AutoTagType: 1,
                MinDealValue: this.form.starttotalAmount,
                MaxDealValue: this.form.endtotalAmount,
                ScaleType: 3,
                customTime: this.form.customTime2.join(','),
              }
            } else {
              obj.autoTagCondition = {
                AutoTagType: 1,
                MinDealValue: this.form.starttotalAmount,
                MaxDealValue: this.form.endtotalAmount,
                ScaleType:
                  this.form.isAutoTagItemAmountMoths == 3 ? 0 : this.form.isAutoTagItemAmountMoths == 6 ? 1 : 2,
              }
            }
          } else {
            obj.starttotalAmount = null
            obj.endtotalAmount = null
            obj.isAutoTagItemAmountMoths = null
            if (this.form.isAutoTagItemTranMoths == 99) {
              obj.autoTagCondition = {
                AutoTagType: 0,
                MinDealValue: this.form.starttotalTransaction,
                MaxDealValue: this.form.endtotalTransaction,
                ScaleType: 3,
                customTime: this.form.customTime1.join(','),
              }
            } else {
              obj.autoTagCondition = {
                AutoTagType: 0,
                MinDealValue: this.form.starttotalTransaction,
                MaxDealValue: this.form.endtotalTransaction,
                ScaleType: this.form.isAutoTagItemTranMoths == 3 ? 0 : this.form.isAutoTagItemTranMoths == 6 ? 1 : 2,
              }
            }
          }
        }
        obj.autoTagCondition = JSON.stringify(obj.autoTagCondition)
        obj.isAutoTag = obj.isAutoTag == 0 ? true : false
        console.log(obj)
        VipTag.createOrUpdate(obj).then((res) => {
          this.$router.push({
            name: 'vipTagList',
          })
        })
      }
    })
  }
  changeCustomTime1(e) {
    this.form.customTime1 = e
  }
  changeCustomTime2(e) {
    this.form.customTime2 = e
  }
}
